"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { useLanguage } from "@/contexts/LanguageContext";
import type { PostMeta } from "@/lib/posts";
interface PostHeaderProps {
  post: PostMeta;
}
export default function PostHeader(t0) {
  const $ = _c(38);
  const {
    post
  } = t0;
  const {
    t
  } = useLanguage();
  let t1;
  if ($[0] !== post.date) {
    t1 = new Date(`${post.date}T00:00:00`).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric"
    });
    $[0] = post.date;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const formattedDate = t1;
  let t2;
  if ($[2] !== post.coverImage || $[3] !== post.title) {
    t2 = <div className="relative mb-8 aspect-video w-full overflow-hidden rounded-xl"><Image src={post.coverImage} alt={post.title} fill={true} className="object-cover" sizes="(max-width: 768px) 100vw, 800px" priority={true} /></div>;
    $[2] = post.coverImage;
    $[3] = post.title;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== post.title) {
    t3 = <h1 className="mb-4 text-3xl font-bold text-text-primary md:text-4xl lg:text-5xl">{post.title}</h1>;
    $[5] = post.title;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("posts.by");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== post.author || $[10] !== t4) {
    t5 = <span>{t4} {post.author}</span>;
    $[9] = post.author;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span aria-hidden="true" className="text-text-muted">·</span>;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = post.date;
  let t8;
  if ($[13] !== t) {
    t8 = t("posts.publishedOn");
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== formattedDate || $[16] !== post.date || $[17] !== t8) {
    t9 = <time dateTime={t7}>{t8} {formattedDate}</time>;
    $[15] = formattedDate;
    $[16] = post.date;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <span aria-hidden="true" className="text-text-muted">·</span>;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  const t11 = post.readingTime;
  let t12;
  if ($[20] !== t) {
    t12 = t("posts.minRead");
    $[20] = t;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== post.readingTime || $[23] !== t12) {
    t13 = <span>{t11} {t12}</span>;
    $[22] = post.readingTime;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t13 || $[26] !== t5 || $[27] !== t9) {
    t14 = <div className="mb-6 flex flex-wrap items-center gap-x-4 gap-y-2 text-sm text-text-secondary">{t5}{t6}{t9}{t10}{t13}</div>;
    $[25] = t13;
    $[26] = t5;
    $[27] = t9;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== post.tags) {
    t15 = post.tags.map(_temp);
    $[29] = post.tags;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t15) {
    t16 = <div className="flex flex-wrap gap-2">{t15}</div>;
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t14 || $[34] !== t16 || $[35] !== t2 || $[36] !== t3) {
    t17 = <header className="mb-10">{t2}{t3}{t14}{t16}</header>;
    $[33] = t14;
    $[34] = t16;
    $[35] = t2;
    $[36] = t3;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  return t17;
}
function _temp(tag) {
  return <span key={tag} className="rounded-full bg-brand-primary/10 px-3 py-1 text-xs font-medium text-brand-primary">{tag}</span>;
}